module.exports = __webpack_public_path__ + "img/adulto36.952bfd5e.jpg";